exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".msg-modal .modal-dialog {\n  width: 420px;\n  top: 30%; }\n\n.msg-modal .modal-header {\n  padding: 17px 25px;\n  height: 50px;\n  background: #f2f4f7;\n  border-radius: 5px 5px 0px 0px;\n  color: #28292b;\n  font-size: 16px;\n  font-weight: 700; }\n\n.msg-modal .modal-body {\n  height: 162px;\n  border-radius: 0px 0px 5px 5px;\n  color: #28292b;\n  font-size: 14px;\n  font-weight: 400;\n  text-align: center;\n  padding: 0px; }\n  .msg-modal .modal-body .ok-sign {\n    width: 72px;\n    height: 72px;\n    margin: 28px auto 20px auto;\n    background-image: url(\"/resources/images/ok_sign.png\"); }\n\n.msg-modal .modal-footer {\n  height: 76px;\n  border-radius: 0px 0px 5px 5px;\n  padding-top: 20px;\n  text-align: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?{"data":"$env: '';"}!./src/components/Console/Modal/MsgModal/style.scss
// module id = 667
// module chunks = 26